import React from 'react'
import PropTypes from 'prop-types'
import { Button } from 'lp-components'
import { ButtonLink } from 'components'
import { makeMemberApplicationPath, PATH } from 'config'

const propTypes = {
  logoutAndReturnToApp: PropTypes.func.isRequired,
}

function UnfoundMembershipDialog({ logoutAndReturnToApp }) {
  return (
    <section className="form-block-container">
      <div className="card card-medium">
        <div className="card-inner">
          <div className="group-block">
            <h3 className="group-title">Become a Member Today</h3>
            <p>
              Good news – you've already created your Sea Tow account on
              the Sea Tow App – now join to get the peace of mind of
              membership, including 24/7 priority on-water assistance,
              unlimited towing in your home area, and essential services like
              fuel delivery, jump starts, disentanglements, covered
              ungroundings, and more.
            </p>
            <div className="button-group">
              <Button
                className="button-primary-outline"
                onClick={logoutAndReturnToApp}
              >
                Go to Homepage
              </Button>
              <ButtonLink
                className="button-primary"
                to={makeMemberApplicationPath(PATH.NEW_MEMBER_QUESTIONNAIRE)}
              >
                Join Now
              </ButtonLink>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

UnfoundMembershipDialog.propTypes = propTypes

export default UnfoundMembershipDialog
